export default __webpack_public_path__ + "static/media/rk3.0540eb85.png";